import { styled } from 'twin.macro';

const Spacer = styled.div`
  ${props =>
    props.my && `margin-top: ${props.my}rem; margin-bottom: ${props.my}rem`};
  ${props => props.mx && `margin-inline-end: ${props.mx}rem; margin-inline-start: ${props.mx}rem`};
  ${props => props.mt && `margin-top: ${props.mt}rem;`};
  ${props => props.mb && `margin-bottom: ${props.mb}rem;`};
  ${props => props.ml && `margin-inline-start: ${props.ml}rem;`};
  ${props => props.mr && `margin-inline-end: ${props.mr}rem;`};
`;

export default Spacer;
